/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHaze = createReactComponent("haze", "IconHaze", [
  ["path", { d: "M3 12h1", key: "svg-0" }],
  ["path", { d: "M12 3v1", key: "svg-1" }],
  ["path", { d: "M20 12h1", key: "svg-2" }],
  ["path", { d: "M5.6 5.6l.7 .7", key: "svg-3" }],
  ["path", { d: "M18.4 5.6l-.7 .7", key: "svg-4" }],
  ["path", { d: "M8 12a4 4 0 1 1 8 0", key: "svg-5" }],
  ["path", { d: "M3 16h18", key: "svg-6" }],
  ["path", { d: "M3 20h18", key: "svg-7" }]
]);

export { IconHaze as default };
//# sourceMappingURL=IconHaze.js.map
